import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
export const buildRetryAlert = ({
  id,
  __error,
  onRetry
}) => {
  // TODO: parse the error into more useful messaging
  // https://git.hubteam.com/HubSpot/PropertiesFrontendTeam/issues/2018

  return {
    id,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.autosave.retryAlertTitle"
    }),
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "customerDataProperties.autosave.retryAlertMessage_jsx",
      options: {
        onClick: onRetry,
        use: 'on-bright'
      },
      elements: {
        Link: UILink
      }
    }),
    type: 'danger'
  };
};
export const buildRefreshAlert = ({
  __error
}) => {
  // TODO: parse the error into more useful messaging
  // https://git.hubteam.com/HubSpot/PropertiesFrontendTeam/issues/2018

  return {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.autosave.refreshAlertTitle"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.autosave.refreshAlertMessage"
    }),
    type: 'danger'
  };
};